import { InputNumber } from "antd";
import React from "react";

/**
 * HourMinuteInput component for entering time duration as separate hour and minute inputs
 */
export const HourMinuteInput = ({ value = 0, onChange, disabled = false, style = {}, maxHours=23 }) => {
  const hours = Math.floor(value / 60);
  const minutes = value % 60;

  const handleHoursChange = (newHours) => {
    const totalMinutes = (newHours || 0) * 60 + minutes;
    onChange(totalMinutes);
  };

  const handleMinutesChange = (newMinutes) => {
    const totalMinutes = hours * 60 + (newMinutes || 0);
    onChange(totalMinutes);
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "4px", ...style }}>
      <InputNumber
        size="small"
        disabled={disabled}
        min={0}
        max={maxHours}
        style={{ width: maxHours > 1000 ? 75 : 50, padding: "2px 4px" }}
        placeholder="hh"
        value={hours}
        onChange={handleHoursChange}
      />
      <span>:</span>
      <InputNumber
        size="small"
        disabled={disabled}
        min={0}
        max={59}
        style={{ width: 60, padding: "2px 4px" }}
        placeholder="mm"
        value={minutes}
        onChange={handleMinutesChange}
      />
    </div>
  );
};
